import { render, staticRenderFns } from "./content-link-selector.vue?vue&type=template&id=8d586d36"
import script from "./content-link-selector.vue?vue&type=script&lang=js"
export * from "./content-link-selector.vue?vue&type=script&lang=js"
import style0 from "./content-link-selector.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/link/content-link-selector.vue
// module id = xCOd
// module chunks = 0